<template>
    <div>

        <!-- Map -->

        <trax-training-course-edit-map :id="id" :bus="bus" 
            :endpoint="endpoint"  :endpoint-params="endpointParams" :learning-units-endpoint="learningUnitsEndpoint"
            :registration-id="registrationId" :user-id="userId" 
            :new-category-label="lang.polaris.common.new_module"
            :index-id="courseId" drag="1" :edit-url-map="editUrlMap"
            :edit-allowed="editAllowed" >
        </trax-training-course-edit-map>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <enac-custom-atpl-phase-edit-item-form :id="id+'-edit'" :toastr-id="id+'-toastr'" :bus="bus"
                :endpoint="endpoint" :learning-units-endpoint="learningUnitsEndpoint"
                :type-code-select="learning_unit_types_select" :index-id="courseId" with-description="1" :registration-id="registrationId">
            </enac-custom-atpl-phase-edit-item-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.form.deletion" :bus="bus">
            {{ lang.polaris.form.confirm_delete_q }}
        </trax-ui-modal-confirm>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'trax-training-course-edit-items'},
            courseId: null,
            registrationId: null,
            userId: null
        },
    
        data: function() {
            return {
                lang: lang,
                user: user,
                endpoint: app_url+'polaris/api/front/sections',
                endpointParams: {
                    options: {
                        ...(data.registration && {registration: data.registration.id}),
                        ...(data.learner && {user: data.learner.id}),
                    },
                },
                learningUnitsEndpoint: app_url+'polaris/api/front/learning-units',
                learning_unit_types_select: data.learning_unit_types_select,
                editUrlMap: {
                    prop: 'type',
                    map: data.learning_unit_edit_routes,
                    assess_map: data.learning_unit_edit_assessment_routes,
                },
                bus: new Vue()
            }
        },

        computed: {

            editAllowed: function() {
                return !this.registrationId || (!this.userId && this.customCollectivePermission) || (this.userId && this.customIndividualPermission);
            },

            customCollectivePermission: function() {
                return this.user.admin || this.user.permissions['dashboard.customize-collective-path'] 
            },

            customIndividualPermission: function() {
                return this.user.admin || this.user.permissions['dashboard.customize-individual-path'] 
            }
        }

    }
</script>
